

// import React, { useEffect, useState, useRef } from 'react';
// import './formreport.css';
// import axios from 'axios';
// import html2pdf from 'html2pdf.js';

// const AdvanceReport = () => {
//   const [reportType, setReportType] = useState('daily');
//   const [viewType, setViewType] = useState('regular');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [farmers, setFarmers] = useState([]);
//   const [selectedFarmer, setSelectedFarmer] = useState('');
//   const [farmerQuery, setFarmerQuery] = useState('');
//   const [showFarmerDropdown, setShowFarmerDropdown] = useState(false);
//   const [reportData, setReportData] = useState([]);
//   const [expandedRows, setExpandedRows] = useState({});
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     fetchFarmers();
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setShowFarmerDropdown(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const fetchFarmers = async () => {
//     try {
//       const res = await axios.get('https://kmtea.onrender.com/farmers');
//       setFarmers(res.data);
//     } catch (err) {
//       console.error('Failed to load farmers', err);
//     }
//   };

//   const filteredFarmers = farmers.filter(f =>
//     f.name.toLowerCase().includes(farmerQuery.toLowerCase()) ||
//     f.farmid.toLowerCase().includes(farmerQuery.toLowerCase())
//   );

//   const handleFarmerSelect = (farmer) => {
//     setSelectedFarmer(farmer.farmid);
//     setFarmerQuery(`${farmer.name} (${farmer.farmid})`);
//     setShowFarmerDropdown(false);
//   };

//   const fetchReport = async () => {
//     try {
//       const res = await axios.get('https://kmtea.onrender.com/advances');
//       let data = res.data;

//       if (selectedFarmer) {
//         data = data.filter(item => item.farmid === selectedFarmer);
//       }

//       const filtered = data.filter(item => {
//         const itemDate = new Date(item.date);
//         const from = fromDate ? new Date(fromDate) : null;
//         const to = toDate ? new Date(toDate) : null;
//         if (from && itemDate < from) return false;
//         if (to && itemDate > to) return false;
//         return true;
//       });

//       const grouped = groupData(filtered);

//       if (viewType === 'total') {
//         setReportData(groupAsTotal(grouped));
//       } else {
//         setReportData(grouped);
//       }
//     } catch (err) {
//       console.error('Error fetching advances:', err);
//     }
//   };

//   const getGroupKey = (date) => {
//     if (reportType === 'daily') {
//       return date.toLocaleDateString('en-GB');
//     }
//     if (reportType === 'weekly') {
//       const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
//       const dayOfMonth = date.getDate();
//       const weekOfMonth = Math.ceil((dayOfMonth + firstDayOfMonth.getDay()) / 7);
//       const monthName = date.toLocaleString('default', { month: 'short' });
//       return `Week ${weekOfMonth} - ${monthName} ${date.getFullYear()}`;
//     }
//     if (reportType === 'monthly') {
//       return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
//     }
//     return '';
//   };

//   const groupData = (data) => {
//     const grouped = data.reduce((acc, item) => {
//       const date = new Date(item.date);
//       const key = getGroupKey(date);
//       if (!acc[key]) {
//         acc[key] = [];
//       }
//       acc[key].push(item);
//       return acc;
//     }, {});

//     return Object.entries(grouped).map(([key, items]) => ({
//       date: key,
//       farmid: items[0].farmid,
//       amount: items.reduce((sum, row) => sum + Number(row.amount || 0), 0),
//       mode: items.map(i => i.mode || '-').join(', '),
//       description: items.map(i => i.description || '-').join(', '),
//       extraInfo: items.map(i => i.extraInfo || '-').join(', ')
//     }));
//   };

//   const groupAsTotal = (data) => {
//     const groupedByDate = data.reduce((acc, row) => {
//       if (!acc[row.date]) {
//         acc[row.date] = [];
//       }
//       acc[row.date].push(row);
//       return acc;
//     }, {});

//     return Object.entries(groupedByDate).map(([date, rows]) => ({
//       date,
//       farmid: rows[0].farmid,
//       amount: rows.reduce((sum, r) => sum + Number(r.amount || 0), 0),
//       mode: [...new Set(rows.map(r => r.mode))].join(', '),
//       descriptions: rows.map(r => r.description),
//       extraInfo: [...new Set(rows.map(r => r.extraInfo))].join(', ')
//     }));
//   };

//   const handleDownload = () => {
//     const element = document.querySelector('.farmer-report__table-container');
//     html2pdf().from(element).save('AdvancePaymentsReport.pdf');
//   };

//   const getFarmerName = (farmid) => {
//     const farmer = farmers.find(f => f.farmid === farmid);
//     return farmer ? farmer.name : farmid;
//   };

//   const toggleExpand = (index) => {
//     setExpandedRows(prev => ({ ...prev, [index]: !prev[index] }));
//   };

//   return (
//     <div className="farmer-report__container">
//       <h2>Advance Payments Report</h2>

//       <div className="farmer-report__filters">
//         {/* Searchable Farmer Dropdown */}
//         <div className="farmer-selector-wrapper" ref={dropdownRef}>
//           <label>Farmer</label>
//           <input
//             type="text"
//             className='drops'
//             placeholder="Select farmer..."
//             value={farmerQuery}
//             onChange={(e) => {
//               setFarmerQuery(e.target.value);
//               setShowFarmerDropdown(true);
//             }}
//             onFocus={() => setShowFarmerDropdown(true)}
//           />
//           {showFarmerDropdown && (
//             <ul className="dropdown">
//               <li
//                 onClick={() => {
//                   setSelectedFarmer('');
//                   setFarmerQuery('All Farmers');
//                   setShowFarmerDropdown(false);
//                 }}
//               >
//                 All Farmers
//               </li>
//               {filteredFarmers.map((farmer) => (
//                 <li key={farmer.farmid} onClick={() => handleFarmerSelect(farmer)}>
//                   {farmer.name} ({farmer.farmid})
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>

//         <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
//           <option value="daily">Daily</option>
//           <option value="weekly">Weekly</option>
//           <option value="monthly">Monthly</option>
//         </select>

//         <select value={viewType} onChange={(e) => setViewType(e.target.value)}>
//           <option value="regular">Regular</option>
//           <option value="total">Total</option>
//         </select>

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <button onClick={fetchReport}>Get Report</button>
//         <button onClick={handleDownload} style={{ background: '#28a745' }}>Download</button>
//       </div>

//       {reportData.length > 0 ? (
//         <div className="farmer-report__table-container">
//           <table className="farmer-report__table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Farmer</th>
//                 <th>Amount</th>
//                 <th>Mode</th>
//                 <th>Description</th>
//                 <th>Extra Info</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reportData.map((entry, index) => (
//                 <tr key={index}>
//                   <td>{entry.date}</td>
//                   <td>{getFarmerName(entry.farmid)}</td>
//                   <td>{entry.amount}</td>
//                   <td>{entry.mode}</td>
//                   <td>
//                     {viewType === 'total' ? (
//                       <>
//                         <button
//                           className="expand-btn"
//                           onClick={() => toggleExpand(index)}
//                         >
//                           {expandedRows[index] ? 'Hide' : 'Show'} ({entry.descriptions.length})
//                         </button>
//                         {expandedRows[index] && (
//                           <ul className="description-list">
//                             {entry.descriptions.map((desc, i) => (
//                               <li key={i}>{desc}</li>
//                             ))}
//                           </ul>
//                         )}
//                       </>
//                     ) : (
//                       entry.description
//                     )}
//                   </td>
//                   <td>{entry.extraInfo}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <div className="farmer-report__no-data">No report data available.</div>
//       )}
//     </div>
//   );
// };

// export default AdvanceReport;


import React, { useEffect, useState, useRef, useMemo } from 'react';
import './formreport.css';
import axios from 'axios';
import html2pdf from 'html2pdf.js';

const AdvanceReport = () => {
  const [reportType, setReportType] = useState('daily');
  const [viewType, setViewType] = useState('regular');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [farmers, setFarmers] = useState([]);
  const [selectedFarmer, setSelectedFarmer] = useState('');
  const [farmerQuery, setFarmerQuery] = useState('');
  const [showFarmerDropdown, setShowFarmerDropdown] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const dropdownRef = useRef(null);

  useEffect(() => {
    fetchFarmers();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowFarmerDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchFarmers = async () => {
    try {
      const res = await axios.get('https://kmtea.onrender.com/farmers');
      setFarmers(res.data);
    } catch (err) {
      console.error('Failed to load farmers', err);
    }
  };

  const filteredFarmers = farmers.filter(f =>
    f.name.toLowerCase().includes(farmerQuery.toLowerCase()) ||
    f.farmid.toLowerCase().includes(farmerQuery.toLowerCase())
  );

  const handleFarmerSelect = (farmer) => {
    setSelectedFarmer(farmer.farmid);
    setFarmerQuery(`${farmer.name} (${farmer.farmid})`);
    setShowFarmerDropdown(false);
  };

  const fetchReport = async () => {
    try {
      const res = await axios.get('https://kmtea.onrender.com/advances');
      let data = res.data;

      if (selectedFarmer) {
        data = data.filter(item => item.farmid === selectedFarmer);
      }

      data = data.filter(item => {
        const itemDate = new Date(item.date);
        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;
        if (from && itemDate < from) return false;
        if (to && itemDate > to) return false;
        return true;
      });

      const grouped = groupData(data);
      setReportData(viewType === 'total' ? groupAsTotal(grouped) : grouped);
    } catch (err) {
      console.error('Error fetching advances:', err);
    }
  };

  const getGroupKey = (date) => {
    if (reportType === 'daily') return date.toLocaleDateString('en-GB');
    if (reportType === 'weekly') {
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const week = Math.ceil((date.getDate() + firstDay.getDay()) / 7);
      return `Week ${week} - ${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
    }
    if (reportType === 'monthly') {
      return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
    }
    return '';
  };

  const groupData = (data) => {
    const grouped = data.reduce((acc, item) => {
      const key = getGroupKey(new Date(item.date));
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    return Object.entries(grouped).map(([key, items]) => ({
      date: key,
      farmid: items[0].farmid,
      amount: items.reduce((sum, r) => sum + Number(r.amount || 0), 0),
      mode: items.map(i => i.mode || '-').join(', '),
      description: items.map(i => i.description || '-').join(', '),
      extraInfo: items.map(i => i.extraInfo || '-').join(', ')
    }));
  };

  const groupAsTotal = (data) => {
    return Object.entries(
      data.reduce((acc, row) => {
        acc[row.date] = acc[row.date] || [];
        acc[row.date].push(row);
        return acc;
      }, {})
    ).map(([date, rows]) => ({
      date,
      farmid: rows[0].farmid,
      amount: rows.reduce((sum, r) => sum + Number(r.amount || 0), 0),
      mode: [...new Set(rows.map(r => r.mode))].join(', '),
      descriptions: rows.map(r => r.description),
      extraInfo: [...new Set(rows.map(r => r.extraInfo))].join(', ')
    }));
  };

  /* ✅ GRAND TOTAL */
  const grandTotal = useMemo(
    () => reportData.reduce((sum, row) => sum + Number(row.amount || 0), 0),
    [reportData]
  );

  const handleDownload = () => {
    html2pdf().from(document.querySelector('.farmer-report__table-container'))
      .save('AdvancePaymentsReport.pdf');
  };

  const getFarmerName = (farmid) => {
    const farmer = farmers.find(f => f.farmid === farmid);
    return farmer ? farmer.name : farmid;
  };

  const toggleExpand = (index) => {
    setExpandedRows(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="farmer-report__container">
      <h2>Advance Payments Report</h2>

      <div className="farmer-report__filters">
        <div className="farmer-selector-wrapper" ref={dropdownRef}>
          <input
            type="text"
            className="drops"
            placeholder="Select farmer..."
            value={farmerQuery}
            onChange={(e) => {
              setFarmerQuery(e.target.value);
              setShowFarmerDropdown(true);
            }}
            onFocus={() => setShowFarmerDropdown(true)}
          />
          {showFarmerDropdown && (
            <ul className="dropdown">
              <li onClick={() => {
                setSelectedFarmer('');
                setFarmerQuery('All Farmers');
                setShowFarmerDropdown(false);
              }}>
                All Farmers
              </li>
              {filteredFarmers.map(f => (
                <li key={f.farmid} onClick={() => handleFarmerSelect(f)}>
                  {f.name} ({f.farmid})
                </li>
              ))}
            </ul>
          )}
        </div>

        <select value={reportType} onChange={e => setReportType(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>

        <select value={viewType} onChange={e => setViewType(e.target.value)}>
          <option value="regular">Regular</option>
          <option value="total">Total</option>
        </select>

        <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />

        <button onClick={fetchReport}>Get Report</button>
        <button onClick={handleDownload} style={{ background: '#28a745' }}>Download</button>
      </div>

      {reportData.length > 0 && (
        <div className="farmer-report__table-container">
          <table className="farmer-report__table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Farmer</th>
                <th>Amount</th>
                <th>Mode</th>
                <th>Description</th>
                <th>Extra Info</th>
              </tr>
            </thead>
            <tbody>
              {reportData.map((row, i) => (
                <tr key={i}>
                  <td>{row.date}</td>
                  <td>{getFarmerName(row.farmid)}</td>
                  <td>{row.amount}</td>
                  <td>{row.mode}</td>
                  <td>
                    {viewType === 'total' ? (
                      <>
                        <button className="expand-btn" onClick={() => toggleExpand(i)}>
                          {expandedRows[i] ? 'Hide' : 'Show'} ({row.descriptions.length})
                        </button>
                        {expandedRows[i] && (
                          <ul className="description-list">
                            {row.descriptions.map((d, k) => <li key={k}>{d}</li>)}
                          </ul>
                        )}
                      </>
                    ) : row.description}
                  </td>
                  <td>{row.extraInfo}</td>
                </tr>
              ))}

              {/* ✅ GRAND TOTAL ROW */}
              <tr className="grand-total-row">
                <td colSpan="2"><strong>Grand Total</strong></td>
                <td><strong>{grandTotal}</strong></td>
                <td colSpan="3"></td>
              </tr>

            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdvanceReport;
